import {useMemo} from 'react'

import PropTypes from 'prop-types'

import {BASE_CLASS} from '../../config.js'

const PanelPriceIndicatorFaqs = ({faqs}) => {
  const faqsParagraphs = useMemo(() => faqs.map(faq => <p className={`${BASE_CLASS}-faqsText`}>{faq}</p>), [faqs])

  return <div className={`${BASE_CLASS}-faqs`}>{faqsParagraphs}</div>
}

PanelPriceIndicatorFaqs.propTypes = {
  faqs: PropTypes.arrayOf(PropTypes.string)
}

export default PanelPriceIndicatorFaqs
